import Vue from 'vue'
import VueStorage from 'vue-ls'
import VueLazyload from 'vue-lazyload'
// ant-design-vue 按需加载
import {
  ConfigProvider,
  Layout,
  Input,
  InputNumber,
  Button,
  Switch,
  Radio,
  Checkbox,
  Select,
  Card,
  Form,
  FormModel,
  Row,
  Col,
  Modal,
  Table,
  Tabs,
  Icon,
  Badge,
  Popover,
  Dropdown,
  List,
  Avatar,
  Steps,
  Spin,
  Menu,
  Drawer,
  Tooltip,
  Alert,
  Tag,
  Divider,
  DatePicker,
  TimePicker,
  Upload,
  Progress,
  Skeleton,
  Popconfirm,
  message,
  notification,
  Cascader,
  Tree,
  Pagination,
  Descriptions,
  Empty,
  Breadcrumb,
  PageHeader
} from 'ant-design-vue'

// ext library

// vue-ls 本地储存配置
const storageOptions = {
  namespace: 'PRESALE__', // key prefix
  name: 'ls', // name variable Vue.[ls] or this.[$ls],
  storage: 'local' // storage name session, local, memory
}
// import VueCropper from 'vue-cropper'
// import PageLoading from '@/components/PageLoading'

message.config({ maxCount: 1 })
Vue.prototype.$message = message
Vue.prototype.$notification = notification

Vue.prototype.$modal = Modal
Vue.prototype.$confirm = Modal.confirm
Vue.prototype.$info = Modal.info
Vue.prototype.$success = Modal.success
Vue.prototype.$error = Modal.error
Vue.prototype.$warning = Modal.warning
Vue.prototype.$simpleEmpty = Empty.PRESENTED_IMAGE_SIMPLE

Vue.use(ConfigProvider)
Vue.use(Layout)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Button)
Vue.use(Switch)
Vue.use(Radio)
Vue.use(Checkbox)
Vue.use(Select)
Vue.use(Card)
Vue.use(Form)
Vue.use(FormModel)
Vue.use(Row)
Vue.use(Col)
Vue.use(Modal)
Vue.use(Table)
Vue.use(Tabs)
Vue.use(Icon)
Vue.use(Badge)
Vue.use(Popover)
Vue.use(Dropdown)
Vue.use(List)
Vue.use(Avatar)
Vue.use(Steps)
Vue.use(Spin)
Vue.use(Menu)
Vue.use(Drawer)
Vue.use(Tooltip)
Vue.use(Alert)
Vue.use(Tag)
Vue.use(Divider)
Vue.use(DatePicker)
Vue.use(TimePicker)
Vue.use(Upload)
Vue.use(Progress)
Vue.use(Skeleton)
Vue.use(Popconfirm)
Vue.use(notification)
Vue.use(Cascader)
Vue.use(Tree)
Vue.use(Pagination)
Vue.use(Descriptions)
Vue.use(Empty)
Vue.use(Breadcrumb)
Vue.use(PageHeader)

// Vue.use(VueCropper)
// Vue.use(PageLoading)
Vue.use(VueStorage, storageOptions)

Vue.use(VueLazyload)
